import clsx from 'clsx'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  height?: number | string
  width?: number | string
}

const SkeletonLoader: React.FC<Props> = ({
  height,
  width,
  className,
  ...props
}) => {
  return (
    <div
      className={clsx('skeleton-box', className)}
      style={{
        height,
        width,
      }}
      {...props}
    >
      &nbsp;
    </div>
  )
}

export default SkeletonLoader
